var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8156 11L15.9172 6.11094C15.9859 6.02969 15.9281 5.90625 15.8219 5.90625H14.575C14.5015 5.90625 14.4312 5.93906 14.3828 5.99531L11 10.0281L7.61717 5.99531C7.57029 5.93906 7.49998 5.90625 7.42498 5.90625H6.1781C6.07185 5.90625 6.01404 6.02969 6.08279 6.11094L10.1844 11L6.08279 15.8891C6.06739 15.9072 6.05751 15.9293 6.05432 15.9529C6.05114 15.9764 6.05478 16.0004 6.06481 16.022C6.07485 16.0435 6.09086 16.0617 6.11094 16.0745C6.13102 16.0872 6.15433 16.0939 6.1781 16.0938H7.42498C7.49842 16.0938 7.56873 16.0609 7.61717 16.0047L11 11.9719L14.3828 16.0047C14.4297 16.0609 14.5 16.0938 14.575 16.0938H15.8219C15.9281 16.0938 15.9859 15.9703 15.9172 15.8891L11.8156 11Z",
    fill: "white",
    fillOpacity: 0.45
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#7396AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.30368b1ca861863c8148f720d2ea00ed.svg";
export { ForwardRef as ReactComponent };